import { Box } from '@chakra-ui/react';
import { RenderElementPropsFor, SlateAttributes } from '@texas/extensions';
import React from 'react';
import { getChatEntityColor } from '../entityStyles';
import { EntityElement } from '../extensions';
import { ChatMessageEntityLinkType } from '@texas/api/endpoints/chat/chatApi';
import { HoverCard } from '@texas/components/shared/HoverCard';
import { hoverCards } from './hoverCards/hoverCards';
import { ensureEnumNumber } from '@texas/utils/helpers/enumHelpers';

export function EntityValue({
  children,
  attributes,
  element,
}: RenderElementPropsFor<EntityElement>) {
  return (
    <EntityValueDesign
      type={element.entityType}
      id={element.entityId}
      attributes={attributes}
    >
      <div contentEditable={false}>
        <React.Fragment>
          {element.label}
          {children}
        </React.Fragment>
      </div>
    </EntityValueDesign>
  );
}

export function EntityValueDesign({
  children,
  id,
  type,
  attributes,
}: {
  children: React.ReactNode;
  id: number;
  type: ChatMessageEntityLinkType;
  attributes?: SlateAttributes;
}) {
  return (
    <HoverCard
      content={hoverCards[ensureEnumNumber(ChatMessageEntityLinkType, type)]?.(
        id,
      )}
    >
      <Box
        {...attributes}
        as="span"
        color={getChatEntityColor(type)}
        display="inline-block"
        textTransform="uppercase"
        textDecoration="underline"
      >
        {children}
      </Box>
    </HoverCard>
  );
}
